import { Button } from 'react-bootstrap';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import resume1 from '../../images/resume/resume1.png';
import resume2 from '../../images/resume/resume2.png';
import resume from '../../images/resume.pdf';

const Resume = () => {
    const style = {
        width: "50vw",
    }
    return (
        <div className="App container-about">
            <Button href={resume} variant="outline-dark btn-border m-3" download>
                DOWNLOAD RESUME
            <FontAwesomeIcon className="icon-color custom-icon ml-2" icon={faDownload} />
            </Button>
            <div style={{ minHeight: "100vh" }}>
                <img style={style} src={resume1} alt="" />
                <br /><br />
                <img style={style} src={resume2} alt="" />
            </div>
        </div>
    );
};

export default Resume;